import {
  CUSTOM_FIELD_VALIDATION_RULE_FETCH_REQUEST,
  CUSTOM_FIELD_VALIDATION_RULE_FETCH_REQUEST_SUCCESS,
  CUSTOM_FIELD_VALIDATION_RULE_FETCH_REQUEST_FAILURE,
  CUSTOM_FIELD_VALIDATION_RULE_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

const customFieldValidationRulesReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case CUSTOM_FIELD_VALIDATION_RULE_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case CUSTOM_FIELD_VALIDATION_RULE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case CUSTOM_FIELD_VALIDATION_RULE_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case CUSTOM_FIELD_VALIDATION_RULE_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

export default customFieldValidationRulesReducer;
